// extracted by mini-css-extract-plugin
export default {"departmentclosed":"OpeningHours_departmentclosed__BBcMs","opening-reminder":"OpeningHours_opening-reminder__m14d5","dept":"OpeningHours_dept__bVcAp"};